import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useReceivement } from '../../hooks/useReceivement'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import { assignDockByHash } from '../../services/docks/dockService'
import { useDispatch } from 'react-redux'
import { actions } from 'src/features/state'
import { Typography } from '@mui/material'
import { useForm } from 'react-hook-form'
import { handleOnKeyDown } from 'src/utils/Form'
import * as S from './DockAssignPage.styles'

const DockAssignPage = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const history = useHistory()
  const { search } = useLocation()
  const { supervisorBadge } = useReceivement({
    validateSupervisor: true,
  })

  const { fc, validateFc } = useFulfillmentCenter()

  const dispatch = useDispatch()

  const handleSetDefaultDock = async ({ dockBarcode }) => {
    try {
      dispatch(actions.isLoading(true))
      const result = await assignDockByHash(supervisorBadge, fc.id, dockBarcode)
      if (result.isOk) {
        setDockOnLocalStorage(result.data.dock)
        const nextLocation = search.substring(6)
        history.push(nextLocation)
      } else {
        toast.error(result.data?.message || 'Falha ao associar a doca')
      }
    } catch (error) {
      toast.error('Falha ao associar a doca!')
    } finally {
      dispatch(actions.isLoading(false))
    }
  }

  useEffect(() => {
    validateFc()
  }, [validateFc])

  const setDockOnLocalStorage = (dock) => {
    const currentDock = {
      id: dock.id,
      defaultLocationId: dock.default_location_id,
      code: dock.code,
      is_fresh: dock.is_fresh,
      id_fc: dock.fulfillment_center_id,
    }

    localStorage.setItem('currentDock', JSON.stringify(currentDock))

    dispatch(actions.setAssignedDock({
      id: currentDock.id,
      code: currentDock.code,
      defaultLocationId: currentDock.defaultLocationId,
      isFresh: currentDock.is_fresh,
      fulfillmentCenterId: currentDock.id_fc,
    }))
  }

  return (
    <S.Wrapper>
      <S.Card>
        <S.CardHeader>
          <Typography variant='h5'>
            Vincular Doca
          </Typography>
        </S.CardHeader>
        <S.CardBody>
          <Typography variant='h6'>
            Bipe o código de barras da doca:
          </Typography>
          <S.CustomTextField
            id='dockBarcode'
            name='dockBarcode'
            type='password'
            autoComplete='new-password'
            onCut={(e) => e.preventDefault()}
            onCopy={(e) => e.preventDefault()}
            onPaste={(e) => e.preventDefault()}
            autoFocus
            inputProps={{
              ...register('dockBarcode', {
                required: 'Campo obrigatório!',
              }),
              'data-testid': 'dock-barcode-test-id',
            }}
            label='Código de barras'
            error={!!errors.dockBarcode}
            helperText={!!errors.dockBarcode && errors.dockBarcode.message}
            fullWidth
            size='medium'
            onKeyDown={(e) => handleOnKeyDown(e, '', handleSubmit(handleSetDefaultDock))}
          />
        </S.CardBody>
      </S.Card>
    </S.Wrapper>
  )
}

export default DockAssignPage
